export default __webpack_public_path__ + "static/media/dart.9ff1e671.svg";